import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AuthService } from 'src/app/login/auth.service';
import { UserService } from 'src/app/services/user.service';
import { User, WriteOffMoneyDoc } from 'src/typings';
import { environment } from 'src/environments/environment';
import { normalizeDateRangePayload } from 'src/app/shared/utils/date-filter.util';

@Injectable({
  providedIn: 'root'
})
export class WiteOffMoneyService {
  user: User | undefined;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private userService: UserService
  ) {
    this.userService.user.subscribe((user) => {
      this.user = user;
    });
  }

  search(payload: {
    id: number;
    date_from: Date;
    date_to: Date;
    user_id: number;
    description: string;
    bank_id: number;
  }) {
    const normalizedPayload = normalizeDateRangePayload(payload);
    return this.http
      .post<
        {
          id: number;
          value: number;
          date: Date;
          passed: boolean;
          description: string;
          user: string;
          bank: string;
          commission: number;
        }[]
      >(`${environment.BACKEND}/doc/write-off-money/search`, normalizedPayload)
      .pipe(
        map((data) => {
          return data.map((obj) => {
            return (obj = { ...obj, date: new Date(obj.date) });
          });
        })
      );
  }

  getList() {
    return this.http
      .get<
        {
          id: number;
          value: number;
          date: Date;
          passed: boolean;
          description: string;
          user: string;
          bank: string;
          commission: number;
        }[]
      >(`${environment.BACKEND}/doc/write-off-money/list`)
      .pipe(
        map((data) => {
          return data.map((obj) => {
            return (obj = { ...obj, date: new Date(obj.date) });
          });
        })
      );
  }

  getOne(id: number) {
    return this.http.get<WriteOffMoneyDoc>(`${environment.BACKEND}/doc/write-off-money/${id}`);
  }

  save(payload: {
    id: number;
    value: number;
    date: Date;
    passed: boolean;
    description: string;
    bank_id: number;
    commission: number;
  }) {
    return this.http.put<WriteOffMoneyDoc>(
      `${environment.BACKEND}/doc/write-off-money/save`,
      payload
    );
  }

  create(payload: {
    date: Date;
    value: number;
    commission: number;
    passed: boolean;
    description: string;
    bank_id: number;
  }) {
    return this.http.post<WriteOffMoneyDoc>(
      `${environment.BACKEND}/doc/write-off-money/create`,
      payload
    );
  }

  delete(id: number) {
    return this.http.delete(`${environment.BACKEND}/doc/write-off-money/${id}`);
  }
}
